import {Component, EventEmitter, Input, Output} from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss']
})
export class SearchbarComponent {

  icon='';
  
  @Output() queryEvent: EventEmitter<string> = new EventEmitter()

  @Input() data: string = ''
  @Input() suggestion: boolean = false

  suggests: any
  constructor(private api: ApiService, private confs: ConfigService) {
  }

  search() {
    if (this.data.length > 2)
      this.queryEvent.emit(this.data)
  }

  selectSuggestion(q: string){
    this.data = q;
    this.getSuggestions()
  }

  getSuggestions() {
    if (this.confs.getConfig().activeteSuggestions && this.suggestion){
      if (this.data.length > 2){
        this.api.suggestion(this.data).subscribe({
          next: (res: any) => {
            this.suggests = res.data;
          },
          error: (err) => console.log(err)
        })
      } else {
        this.suggests = []
      }
    }
  }
}

